import { render, staticRenderFns } from "./gitlab_version_check_badge.vue?vue&type=template&id=74ede219"
import script from "./gitlab_version_check_badge.vue?vue&type=script&lang=js"
export * from "./gitlab_version_check_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports